export const MEASUREMENT_DATE_SLUG = 'measurement-date';
export const SMALL_FONT_SIZE = '0.75rem';
export const VALUATION_TYPE_409A = 1;
